import { ArrayInput, TextField } from "react-admin";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";
import { ListIterator } from "../../common/list/compact-list/ListIterator";
import resourceNames from "../../../common/data/resourceNames";
import { useForm } from "react-final-form";
import { RecordStatus } from "../../../common/data/service-proxies";

interface Props {}

export const VehicleSelectionGrid = (props: Props) => {
  const form = useForm();
  const tenantIdState = form.getFieldState("tenantId");

  return tenantIdState?.value ? (
    <ProtectedElement source="vehicleIds" label="" {...props}>
      <ArrayInput source="vehicleIds">
        <ListIterator
          reference={resourceNames.ADMIN_VEHICLES_VIEW}
          sort={{ field: "name", order: "asc" }}
          filter={{
            tenantId: tenantIdState?.value,
            status: RecordStatus.Active,
          }}
        >
          <TextField
            source="name"
            label="resources.admin-vehicles.labels.vehicleId"
          />
        </ListIterator>
      </ArrayInput>
    </ProtectedElement>
  ) : null;
};
